package com.example.mystybag.login.logic

import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.login.model.MerchantRegistrationSuccessUIState

class MerchantRegistrationUnderReviewViewModel(
    context: AppContext
) : ChildViewModel<MerchantRegistrationSuccessUIState>(context, MerchantRegistrationSuccessUIState()) {

    override fun onCreate() {
        navControls.backButtonVisible = false
    }

    fun onAcknowledgeClicked() {
        replaceAll(NavigatorWelcome)
    }
}
